import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import type { SearchMessageResult } from '@/hooks/search/use-search-messages';
import ROUTES from '@/routes';
import SearchListItem from './search-list-item';

interface Props {
  keyword?: string;
  selectedMessageSet?: SearchMessageResult;
}

export default function SearchMessageResultDetail({ keyword = '', selectedMessageSet }: Props) {
  const { t } = useTranslation();

  if (!selectedMessageSet) return null;

  return (
    <div className='relative flex-1 overflow-auto'>
      <h4 className='sticky top-0 pt-1 mb-2 bg-neutral-0 px-5 text-body1 font-bold'>
        “{keyword}” {t('search.related-chat-record', { count: selectedMessageSet.SearchResultDetails.length })}
      </h4>

      {selectedMessageSet.SearchResultDetails.map(({ Id, HeaderImg, Message, CreateTime, NickName }) => {
        const isGroup = 'GroupId' in selectedMessageSet && selectedMessageSet.GroupId !== 0;

        return (
          <Link
            key={Id}
            to={
              isGroup
                ? ROUTES.MESSAGES.GROUPS.$buildPath({
                    params: { id: selectedMessageSet.GroupId },
                    searchParams: { search: Id },
                  })
                : ROUTES.MESSAGES.SESSIONS.$buildPath({
                    params: { id: selectedMessageSet.ChatSessionId },
                    searchParams: { search: Id },
                  })
            }>
            <SearchListItem
              key={Id}
              avatarImageUrl={HeaderImg}
              title={NickName}
              description={Message}
              highlight={keyword}
              highlightField='description'
              suffix={dayjs(CreateTime).fromNow()}
            />
          </Link>
        );
      })}
    </div>
  );
}
